// extracted by mini-css-extract-plugin
module.exports = {"favoriteTeamShop":"FavoriteTeamShopBox_favoriteTeamShop__GmruB","container":"FavoriteTeamShopBox_container__QXn9Y"};